import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AgentRelationSearchComponent } from './agent-relation-search/agent-relation-search.component';
import { TeamAgentRelationSearchComponent } from './team-agent-relation-search/team-agent-relation-search.component';
import { AuthGuardService } from '../auth-guard.service';

const routes: Routes = [
  {
    path: 'search-agent-relations',
    component: AgentRelationSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-team-agent-relations',
    component: TeamAgentRelationSearchComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AgentRelationRoutingModule {}
